import PublishIcon from "@mui/icons-material/Publish";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import PeopleIcon from "@mui/icons-material/People";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DeleteIcon from "@mui/icons-material/Delete";
import CancelIcon from "@mui/icons-material/Cancel";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import ListIcon from "@mui/icons-material/List";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DiamondIcon from "@mui/icons-material/Diamond";
import EmailIcon from '@mui/icons-material/Email';
import ContactsIcon from '@mui/icons-material/Contacts';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import MenuIcon from "@mui/icons-material/Menu";
import LockOutlined from "@mui/icons-material/LockOutlined";
import AddIcon from '@mui/icons-material/Add';
import CategoryIcon from '@mui/icons-material/Category';
import Search from "@mui/icons-material/Search";
import Clear from "@mui/icons-material/Clear";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import EditIcon from '@mui/icons-material/Edit';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import CallMadeIcon from '@mui/icons-material/CallMade';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';
import GroupIcon from '@mui/icons-material/Group';
import AssessmentIcon from '@mui/icons-material/Assessment';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Error from "@mui/icons-material/Error";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import UndoOutlinedIcon from '@mui/icons-material/UndoOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import QrCode2OutlinedIcon from '@mui/icons-material/QrCode2Outlined';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import InfoIcon from '@mui/icons-material/Info';
import UploadIcon from '@mui/icons-material/Upload';
import TuneOutlined from '@mui/icons-material/TuneOutlined';

export const Icons = {
  ArrowOutwardIcon: ArrowOutwardIcon,
  QrCode2OutlinedIcon: QrCode2OutlinedIcon,
  OpenInNewIcon: OpenInNewIcon,
  UpArrow: PublishIcon,
  DownArrow: DownloadIcon,
  VisibilityIcon: VisibilityIcon,
  VisibilityOff: VisibilityOff,
  Close: CloseIcon,
  Error: Error,
  CustomersIcon: PeopleIcon,
  PeopleOutlineIcon: PeopleOutlineIcon,
  RupeeIcon: CurrencyRupeeIcon,
  InterestIcon: AutorenewIcon,
  Trash: DeleteIcon,
  Cross: CancelIcon,
  Invoice: ReceiptIcon,
  AddCustomer: PersonAddIcon,
  AddLoanApplication: RequestQuoteIcon,
  Dashboard: SpaceDashboardIcon,
  List: ListIcon,
  PDFIcon: PictureAsPdfIcon,
  Products: DiamondIcon,
  Email: EmailIcon,
  Contacts: ContactsIcon,
  UserProfileIcon: AccountCircleIcon,
  SettingsIcon: SettingsIcon,
  LogoutIcon: LogoutIcon,
  DownArrowAngleIcon: KeyboardArrowDownIcon,
  LeftArrowAngleIcon: KeyboardArrowLeftIcon,
  RightArrowAngleIcon: KeyboardArrowRightIcon,
  UpArrowAngleIcon: KeyboardArrowUpIcon,
  ExpandLessIcon: ExpandLess,
  ExpandMoreIcon: ExpandMore,
  MenuIcon: MenuIcon,
  LockOutlinedIcon: LockOutlined,
  AddIcon: AddIcon,
  CategoryIcon: CategoryIcon,
  Search: Search,
  Clear: Clear,
  FileDownloadIcon: FileDownloadIcon,
  KeyboardTabIcon: KeyboardTabIcon,
  ChevronLeftIcon: ChevronLeftIcon,
  ChevronRightIcon: ChevronRightIcon,
  TaskAltIcon: TaskAltIcon,
  EditIcon: EditIcon,
  PowerSettingsNewIcon: PowerSettingsNewIcon,
  NetworkCheckIcon: NetworkCheckIcon,
  WifiOffIcon: WifiOffIcon,
  CallReceivedIcon: CallReceivedIcon,
  CallMadeIcon: CallMadeIcon,
  PendingActionsIcon: PendingActionsIcon,
  AutoAwesomeMosaicIcon: AutoAwesomeMosaicIcon,
  GroupIcon: GroupIcon,
  AssessmentIcon: AssessmentIcon,
  MonitorHeartIcon: MonitorHeartIcon,
  KeyboardBackspaceIcon: KeyboardBackspaceIcon,
  UndoOutlinedIcon: UndoOutlinedIcon,
  ReplayOutlinedIcon: ReplayOutlinedIcon,
  FilterAltOutlinedIcon: FilterAltOutlinedIcon,
  UploadFileIcon: UploadFileIcon,
  CloudUploadIcon: CloudUploadIcon,
  UploadIcon: UploadIcon,
  InfoOutlineIcon,
  InfoIcon,
  TuneOutlined,
};
